import React from 'react'
import GooglePayButton from '@google-pay/button-react'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const GooglePayHL = (props) => {
    const {faciltyData, getValues, onSubmit, setIsSubmittingForm} = props
    

    const paymentDataResponse = (paymentResponse) => {
        setIsSubmittingForm(true)
        
        // let objResp = JSON.parse(paymentResponse.paymentMethodData.tokenizationData.token)
        // let objResp2 = JSON.stringify(paymentResponse)
        // console.log('load payment data', paymentResponse, objResp)
        // console.log('token', JSON.stringify(paymentResponse.paymentMethodData.tokenizationData.token))
        // console.log('payment', paymentResponse)
        const formData = getValues()
        const finalData = {...formData, walletPay: paymentResponse?.paymentMethodData?.tokenizationData?.token}
        finalData.paymentMethod = 'GPAY'
        onSubmit(finalData)
    }

    return (
        <div className='px-4 payButton'>
            <GooglePayButton
                buttonColor='default'
                buttonType='buy'
                environment={faciltyData?.facility?.facility_payment_details?.heartland_payment_env.toUpperCase() === 'TEST' ? 'TEST' : 'PRODUCTION'}
                paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                        {
                            type: 'CARD',
                            parameters: {
                                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'],
                            },
                            tokenizationSpecification: {
                                type: 'PAYMENT_GATEWAY',
                                parameters: {
                                    gateway: 'globalpayments',
                                    gatewayMerchantId: faciltyData?.facility?.facility_payment_details?.heartland_merchant_id,
                                },
                            },
                        },
                    ],
                    merchantInfo: {
                        merchantId: faciltyData?.facility?.facility_payment_details?.heartland_gpay_merchant,
                        merchantName: faciltyData?.facility?.facility_payment_details?.heartland_merchant_name,
                    },
                    transactionInfo: {
                        totalPriceStatus: 'FINAL',
                        totalPriceLabel: 'Total',
                        totalPrice: Number(faciltyData?.payable_amount)?.toFixed(2),
                        currencyCode: 'USD',
                        countryCode: 'US',
                    },
                }}
                onLoadPaymentData={paymentDataResponse}
            />
        </div>
    )
}

GooglePayHL.propTypes = {
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
}
 
GooglePayHL.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
}

export default GooglePayHL
